<div class="flex flex-col h-full w-full" [ngClass]="{ absolute: !isDesktop }">
  <vip-screen-title
    *ngIf="!isDesktop || isDesktopResponsive"
    title="Novo Cartão"
    leftIcon="icon-arrow_back"
    leftIconColor="secondary"
    (goBackClicked)="backClick.emit()"
    [showActions]="true"
  >
  </vip-screen-title>
  <div class="flex flex-col flex-grow">
    <div class="flex flex-col flex-grow m-3">
      <div
        class="flex flex-col items-center mb-4"
        [ngClass]="{ 'items-baseline': isDesktop, 'items-center': !isDesktop }"
        *ngIf="!privateLabelBandeiraAutomatica"
      >
        <p
          class="vip-color-secondary-default mb-2 tracking-tight"
          [ngClass]="{ 'text-sm': !isDesktop, 'text-xs': isDesktop }"
        >
          Aceitamos as seguintes bandeiras:
        </p>
        <div
          class="flex flex-wrap gap-1 w-full"
          [ngClass]="{
            'justify-center': !isDesktop,
            'justify-start': isDesktop,
          }"
        >
          <div
            class="vip-credit-card"
            *ngFor="let formaPagamento of formasPagamentoExibidas"
          >
            <vip-image
              [alt]="formaPagamento.descricao"
              [imageUrl]="formaPagamento.logomarca"
            ></vip-image>
          </div>
        </div>
      </div>
      <form [formGroup]="formGroup">
        <div [ngClass]="{ 'flex flex-col': isDesktop }">
          <div
            class="grid gap-3"
            [ngClass]="{
              'grid-cols-1': !isDesktop,
              'vip-grid-cols-desktop': isDesktop,
            }"
          >
            <div class="relative">
              <input type="hidden" formControlName="cc_number" />
              <vip-field
                label="NÚMERO DO CARTÃO*"
                [error]="
                  formGroup.controls.cc_number.touched &&
                  formGroup.controls.cc_number.invalid
                "
                [message]="validations.cc_number"
                [validations]="formGroup.controls.cc_number.errors"
              >
                <input
                  #ccNumberInput
                  id="cc_number"
                  name="cc-number"
                  autocomplete="cc-number"
                  [attr.aria-label]="'Número do cartão'"
                  type="tel"
                  [dropSpecialCharacters]="false"
                  [mask]="mask"
                  (keyup)="handleBuscarBandeira($event)"
                  (input)="
                    handleBuscarBandeira($event); ccNumber = ccNumberInput.value
                  "
                  (change)="ccNumber = ccNumberInput.value"
                  (blur)="onBlurCcNumber()"
                  [value]="ccNumber"
                />
              </vip-field>
              <div
                *ngIf="formaPagamentoSelecionada"
                class="vip-cartao-bandeira-wrapper input-numero-cartao"
              >
                <vip-image
                  id="cartao-bandeira"
                  [alt]="formaPagamentoSelecionada.descricao"
                  [imageUrl]="formaPagamentoSelecionada.logomarca"
                ></vip-image>
              </div>
            </div>
            <div
              *ngIf="
                isVoucher() ||
                (!permitirBandeiraAutomatica &&
                  !privateLabelBandeiraAutomatica) ||
                permiteSelecaoManual ||
                bandeiraNaoAtendida
              "
              class="relative"
            >
              <vip-select
                id="cc_brand"
                [ngClass]="{
                  'relative-on-mobile': !layoutUtilsService.isDesktop(),
                  'absolute z-40': isDesktop && isScreenLarge,
                }"
                [label]="'BANDEIRA DO CARTÃO*'"
                formControlName="cc_brand"
                [ariaLabel]="'Bandeira do cartão'"
                [message]="validations.default"
                [options]="formaPagamentosOptions"
                [error]="
                  formGroup.controls.cc_brand.touched &&
                  formGroup.controls.cc_brand.invalid
                "
                [validations]="formGroup.controls.cc_brand.errors"
                [value]="formGroup.controls.cc_brand.value"
                (itemSelected)="aoAlterarBandeiraCartao($event.value)"
              ></vip-select>
              <div
                *ngIf="formaPagamentoSelecionada"
                class="vip-cartao-bandeira-wrapper"
              >
                <vip-image
                  id="cartao-bandeira"
                  [alt]="formaPagamentoSelecionada.descricao"
                  [imageUrl]="formaPagamentoSelecionada.logomarca"
                ></vip-image>
              </div>
            </div>
            <div *ngIf="permiteSelecaoManual && !isDesktop">
              <span class="text-xs vip-color-error-main flex"
                >Erro ao tentar identificar a bandeira do seu cartão. Por favor,
                selecione-a manualmente no campo acima.</span
              >
            </div>
            <div
              [ngClass]="{
                'grid gap-4 grid-cols-1': !isDesktop,
                contents: isDesktop,
              }"
            >
              <vip-field
                *ngIf="
                  this.formaPagamentoSelecionada?.bandeira !==
                    'ticket_alimentacao' &&
                  this.formaPagamentoSelecionada?.bandeira !==
                    'ticket_restaurante'
                "
                label="VALIDADE*"
                [error]="
                  formGroup.controls.cc_expire_date.touched &&
                  formGroup.controls.cc_expire_date.invalid
                "
                [message]="validations.cc_expire_date"
                [validations]="formGroup.controls.cc_expire_date.errors"
              >
                <input
                  id="cc_expire_date"
                  name="cc-exp"
                  autocomplete="cc-exp"
                  type="tel"
                  [attr.aria-label]="'Validade do cartão'"
                  formControlName="cc_expire_date"
                  [dropSpecialCharacters]="false"
                  placeholder="00/0000"
                  mask="00/0000||00/00"
                  (input)="verificaFormValido()"
                />
              </vip-field>
              <!-- Mensagem de erro para desktop -->
              <div
                *ngIf="
                  permiteSelecaoManual &&
                  isDesktop &&
                  !formaPagamentoSelecionada
                "
              >
                <span class="text-xs vip-color-error-main flex">
                  Erro ao tentar identificar a bandeira do seu cartão. Por
                  favor, selecione-a manualmente no campo acima.
                </span>
              </div>

              <vip-field
                label="CVV*"
                [error]="
                  formGroup.controls.cc_cvv.touched &&
                  formGroup.controls.cc_cvv.invalid
                "
                [message]="validations.cc_cvv"
                [validations]="formGroup.controls.cc_cvv.errors"
              >
                <input
                  id="cc_cvv"
                  name="cc-csc"
                  autocomplete="cc-csc"
                  type="tel"
                  [attr.aria-label]="'CVV do cartão'"
                  formControlName="cc_cvv"
                  [dropSpecialCharacters]="false"
                  mask="000||0000"
                  (input)="verificaFormValido()"
                />
              </vip-field>
            </div>
            <vip-select
              *ngIf="
                isDesktop &&
                formaPagamentoSelecionada &&
                parcelas &&
                parcelas.length > 0
              "
              data-cy="select-parcelas"
              id="installments"
              class="text-left"
              [ariaLabel]="'Número de parcelas'"
              formControlName="installments"
              [label]="'NÚMERO DE PARCELAS'"
              [message]="{ required: 'Campo obrigatório' }"
              [options]="parcelas || []"
              [value]="parcelaSelecionada"
              [showEmpty]="false"
              (itemSelected)="parcelaChange.emit($event)"
            >
            </vip-select>
            <vip-field
              label="NOME IMPRESSO NO CARTÃO*"
              [error]="
                formGroup.controls.cc_holder.touched &&
                formGroup.controls.cc_holder.invalid
              "
              [message]="validations.default"
              [validations]="formGroup.controls.cc_holder.errors"
            >
              <input
                id="cc_holder"
                name="cc-name"
                autocomplete="cc-name"
                type="text"
                [attr.aria-label]="'Nome impresso no cartão'"
                formControlName="cc_holder"
                (input)="verificaFormValido()"
              />
            </vip-field>
            <vip-field
              label="CPF DO TITULAR*"
              [error]="
                formGroup.controls.cpf_portador.touched &&
                formGroup.controls.cpf_portador.invalid
              "
              [message]="validations.cpf_portador"
              [validations]="formGroup.controls.cpf_portador.errors"
            >
              <input
                id="cpf_portador"
                type="tel"
                formControlName="cpf_portador"
                [attr.aria-label]="'CPF do titular'"
                [dropSpecialCharacters]="false"
                [mask]="masks.cpf"
                (input)="verificaFormValido()"
              />
            </vip-field>
          </div>
          <vip-checkbox
            class="mt-3"
            *ngIf="permitiCofreCartoes"
            [ariaLabel]="'Salvar cartão para compras futuras'"
            formControlName="criar_token"
            label="Deseja salvar esse cartão para compras futuras?"
            data-cy="checkbox-salvar-cartao"
          ></vip-checkbox>
        </div>
      </form>
    </div>
    <div *ngIf="!isDesktop || isDesktopResponsive" class="py-4 px-3 flex">
      <vip-button
        class="w-full"
        data-cy="btn-confimar-compra"
        [ariaLabel]="'Confirmar compra'"
        (btnClick)="submit()"
      >
        Confirmar
      </vip-button>
    </div>
  </div>
</div>
